const getApiBaseUrl = () => (process.env.REACT_APP_API_URL || "").replace(/\/?$/, "/");

const getFileNameFromDisposition = (disposition, fallback) => {
    const value = String(disposition || "");
    const utfMatch = value.match(/filename\*=UTF-8''([^;]+)/i);
    if (utfMatch?.[1]) return decodeURIComponent(utfMatch[1]);
    const plainMatch = value.match(/filename="?([^";]+)"?/i);
    return plainMatch?.[1] || fallback;
};

export const downloadWithProgress = ({
    path,
    filename = "virtalibry-manuscript.pdf",
    onProgress,
    onStatus,
}) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const url = `${getApiBaseUrl()}${String(path || "").replace(/^\/+/, "")}`;

    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.setRequestHeader("Authorization", `Bearer ${localStorage.getItem("token")}`);

    xhr.onprogress = (event) => {
        if (!event.lengthComputable) {
            onStatus?.("Downloading manuscript...");
            onProgress?.(35);
            return;
        }

        const percent = Math.max(1, Math.min(99, Math.round((event.loaded / event.total) * 100)));
        onProgress?.(percent);
        onStatus?.("Downloading manuscript...");
    };

    xhr.onloadstart = () => {
        onProgress?.(3);
        onStatus?.("Preparing secure manuscript download...");
    };

    xhr.onload = () => {
        if (xhr.status < 200 || xhr.status >= 300) {
            reject(new Error(`Download failed: ${xhr.status}`));
            return;
        }

        const blob = xhr.response;
        const downloadName = getFileNameFromDisposition(
            xhr.getResponseHeader("Content-Disposition"),
            filename
        );
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = downloadName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);

        onProgress?.(100);
        onStatus?.("Download complete.");
        resolve({ filename: downloadName });
    };

    xhr.onerror = () => reject(new Error("Network error while downloading manuscript."));
    xhr.onabort = () => reject(new Error("Download was cancelled."));
    xhr.send();
});
